import React from 'react';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import { spacing } from '../../style/theme';
var Wrapper = styled.div.withConfig({
  displayName: "ModalHeader__Wrapper",
  componentId: "sc-1xei0ay-0"
})(["display:flex;justifyContent:space-between;borderBottom:1px solid #c7ced6;alignItems:center;"]);
var Title = styled.h4.withConfig({
  displayName: "ModalHeader__Title",
  componentId: "sc-1xei0ay-1"
})(["flex-grow:1;padding:", "px ", "px;margin-bottom:0;"], spacing.halve, spacing.base);
var CloseButton = styled.button.withConfig({
  displayName: "ModalHeader__CloseButton",
  componentId: "sc-1xei0ay-2"
})(["border:0;color:#213854;cursor:pointer;height:50px;width:60px;"]);

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
      closeModal = _ref.closeModal;
  return React.createElement(Wrapper, null, React.createElement(Title, null, title), React.createElement(CloseButton, {
    onClick: closeModal
  }, React.createElement(MdClose, {
    style: {
      fontSize: '24px'
    }
  })));
};

export default ModalHeader;